export default "__VITE_ASSET__CTSxKFZc__"